import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API from '../utils/api';
import toast from 'react-hot-toast';
import './AuthPages.css';
import './Register.css';

const NAKSHATRAS = ['Ashwini','Bharani','Krittika','Rohini','Mrigashirsha','Ardra','Punarvasu','Pushya','Ashlesha','Magha','Purva Phalguni','Uttara Phalguni','Hastha','Chitra','Swati','Vishakha','Anuradha','Jyeshtha','Mula','Purva Ashadha','Uttara Ashadha','Shravana','Dhanishtha','Shatabhisha','Purva Bhadrapada','Uttara Bhadrapada','Revati'];
const RASIS = ['Mesha','Rishabha','Mithuna','Kataka','Simha','Kanya','Tula','Vrischika','Dhanus','Makara','Kumbha','Meena'];
const LAGNAMS = ['Mesha','Rishabha','Mithuna','Kataka','Simha','Kanya','Tula','Vrischika','Dhanus','Makara','Kumbha','Meena'];
const BLOOD_GROUPS = ['A+','A-','B+','B-','AB+','AB-','O+','O-'];
const HORO_TYPES = ['Sutham','Seva','Rahu Ketu','Seva, Rahu Ketu'];

const STEPS = ['Personal Details','Horoscope Details','Family & Career','Contact & Photo'];

export default function Register() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null);

  const [form, setForm] = useState({
    profile_type: '', god_name: '', full_name: '', full_name_tamil: '',
    dob: '', tob: '', blood_group: '', height: '',
    birth_star: '', rasi: '', lagnam: '', horoscope_type: '',
    education: '', job_profession: '', workplace: '', income: '',
    father_name: '', mother_name: '', siblings_count: '', siblings_married: '',
    caste_subdivision: '', has_property: 'No',
    place_of_birth: '', native_place: '', address: '',
    phone: '', email: '', alternate_phone: '', password: '', confirm_password: '',
    photo: null, horoscope_image: null
  });

  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  const validateStep = () => {
    if (step === 1) {
      if (!form.profile_type) return toast.error('Select Bride or Groom');
      if (!form.full_name) return toast.error('Enter your name');
      if (!form.dob) return toast.error('Enter date of birth');
      if (!form.blood_group) return toast.error('Select blood group');
      if (!form.height) return toast.error('Enter height');
    }
    if (step === 2) {
      if (!form.birth_star) return toast.error('Select birth star');
      if (!form.rasi) return toast.error('Select rasi');
      if (!form.lagnam) return toast.error('Select lagnam');
      if (!form.horoscope_type) return toast.error('Select horoscope type');
    }
    if (step === 3) {
      if (!form.education) return toast.error('Enter education');
      if (!form.father_name) return toast.error('Enter father name');
      if (!form.mother_name) return toast.error('Enter mother name');
      if (!form.caste_subdivision) return toast.error('Enter caste/sub-caste');
    }
    if (step === 4) {
      if (!form.phone || form.phone.length !== 10) return toast.error('Enter valid phone number');
      if (!form.password || form.password.length < 6) return toast.error('Password must be at least 6 characters');
      if (form.password !== form.confirm_password) return toast.error('Passwords do not match');
      if (!form.photo) return toast.error('Upload your photo');
    }
    return true;
  };

  const handleNext = () => {
    if (validateStep() === true) setStep(s => s + 1);
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    set('photo', file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (validateStep() !== true) return;
    setLoading(true);
    try {
      // 1. Check phone already registered
      const { data: chk } = await API.get(`/api/auth/check-phone/${form.phone}`);
      if (chk.exists) {
        toast.error('This phone number is already registered. Please login.');
        setLoading(false);
        return;
      }

      // 2. Register user
      const { data: regData } = await API.post('/api/auth/register', {
        phone: form.phone, password: form.password
      });
      if (!regData.success) { toast.error(regData.message); setLoading(false); return; }

      // Store token
      localStorage.setItem('smm_token', regData.token);

      // 3. Create profile
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => {
        if (k === 'photo' || k === 'horoscope_image' || k === 'confirm_password' || k === 'password') return;
        if (v !== null && v !== '') fd.append(k, v);
      });
      if (form.photo) fd.append('photo', form.photo);
      if (form.horoscope_image) fd.append('horoscope_image', form.horoscope_image);

      await API.post('/api/profiles/create', fd, { headers: { 'Content-Type': 'multipart/form-data' } });

      toast.success('Profile created! Proceed to payment 🙏');
      navigate('/payment');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    }
    setLoading(false);
  };

  const progressPct = ((step - 1) / (STEPS.length - 1)) * 100;

  return (
    <div className="register-page">
      <div className="reg-left">
        <div className="reg-left-content">
          <div className="auth-logo">🪷</div>
          <h2>Join Suvaran Maran Matrimony</h2>
          <p style={{color:'rgba(217,196,169,0.8)',margin:'8px 0 28px'}}>Create your profile and find your perfect life partner</p>
          <div className="reg-steps-list">
            {STEPS.map((s, i) => (
              <div key={s} className={`reg-step-item ${step > i+1 ? 'done' : step === i+1 ? 'active' : ''}`}>
                <div className="rsi-num">{step > i+1 ? '✓' : i+1}</div>
                <span>{s}</span>
              </div>
            ))}
          </div>
          <div className="reg-plan-note">
            <strong>₹499 One-Time Payment</strong>
            <p>Pay after completing your profile. Lifetime access.</p>
          </div>
        </div>
      </div>

      <div className="reg-right">
        {/* Progress Bar */}
        <div className="reg-progress">
          <div className="reg-progress-bar" style={{width:`${progressPct}%`}} />
        </div>

        <div className="reg-form-wrap">
          <div className="reg-step-header">
            <span className="reg-step-num">Step {step} of {STEPS.length}</span>
            <h2>{STEPS[step-1]}</h2>
          </div>

          {/* STEP 1 */}
          {step === 1 && (
            <div className="form-grid">
              <div className="form-group span-2">
                <label className="form-label">Profile For / சுயவிவரம் யாருக்கு</label>
                <div className="radio-group">
                  {['groom','bride'].map(t => (
                    <label key={t} className={`radio-btn ${form.profile_type === t ? 'active' : ''}`}>
                      <input type="radio" value={t} checked={form.profile_type === t} onChange={() => set('profile_type', t)} />
                      {t === 'groom' ? '🤵 Groom / மணமகன்' : '👰 Bride / மணமகள்'}
                    </label>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">God Name / தெய்வம் பெயர்</label>
                <input className="form-input" value={form.god_name} onChange={e => set('god_name', e.target.value)} placeholder="e.g. Murugan" />
              </div>
              <div className="form-group">
                <label className="form-label">Full Name / முழு பெயர் *</label>
                <input className="form-input" value={form.full_name} onChange={e => set('full_name', e.target.value)} placeholder="Enter full name" required />
              </div>
              <div className="form-group span-2">
                <label className="form-label">Full Name in Tamil / தமிழில் பெயர்</label>
                <input className="form-input" value={form.full_name_tamil} onChange={e => set('full_name_tamil', e.target.value)} placeholder="தமிழில் பெயர் உள்ளிடவும்" />
              </div>
              <div className="form-group">
                <label className="form-label">Date of Birth / பிறந்த தேதி *</label>
                <input className="form-input" type="date" value={form.dob} onChange={e => set('dob', e.target.value)} max={new Date().toISOString().split('T')[0]} />
              </div>
              <div className="form-group">
                <label className="form-label">Time of Birth / பிறந்த நேரம்</label>
                <input className="form-input" type="time" value={form.tob} onChange={e => set('tob', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Blood Group / இரத்த வகை *</label>
                <select className="form-select" value={form.blood_group} onChange={e => set('blood_group', e.target.value)}>
                  <option value="">Select Blood Group</option>
                  {BLOOD_GROUPS.map(b => <option key={b}>{b}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Height / உயரம் *</label>
                <select className="form-select" value={form.height} onChange={e => set('height', e.target.value)}>
                  <option value="">Select Height</option>
                  {Array.from({length:24},(_,i)=>{
                    const totalIn = 58+i; const ft=Math.floor(totalIn/12); const inch=totalIn%12;
                    const cm = Math.round(totalIn*2.54);
                    return <option key={i} value={`${ft}'${inch}" (${cm}cm)`}>{ft}'{inch}" ({cm}cm)</option>;
                  })}
                </select>
              </div>
            </div>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Birth Star / நட்சத்திரம் *</label>
                <select className="form-select" value={form.birth_star} onChange={e => set('birth_star', e.target.value)}>
                  <option value="">Select Nakshatra</option>
                  {NAKSHATRAS.map((n,i) => <option key={n} value={n}>{i+1}. {n}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Rasi / ராசி *</label>
                <select className="form-select" value={form.rasi} onChange={e => set('rasi', e.target.value)}>
                  <option value="">Select Rasi</option>
                  {RASIS.map(r => <option key={r}>{r}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Lagnam / லக்னம் *</label>
                <select className="form-select" value={form.lagnam} onChange={e => set('lagnam', e.target.value)}>
                  <option value="">Select Lagnam</option>
                  {LAGNAMS.map(l => <option key={l}>{l}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Caste Sub-Division / சாதி *</label>
                <input className="form-input" value={form.caste_subdivision} onChange={e => set('caste_subdivision', e.target.value)} placeholder="e.g. Vellalar, Mudaliar" />
              </div>
              <div className="form-group span-2">
                <label className="form-label">Horoscope Type / ஜாதக வகை *</label>
                <div className="horo-type-group">
                  {HORO_TYPES.map(t => (
                    <label key={t} className={`horo-type-btn ${form.horoscope_type === t ? 'active' : ''}`}>
                      <input type="radio" value={t} checked={form.horoscope_type === t} onChange={() => set('horoscope_type', t)} />
                      {t}
                    </label>
                  ))}
                </div>
                {form.horoscope_type && (
                  <p className="horo-note">ℹ️ Your profile will only be shown to compatible <strong>{form.horoscope_type}</strong> profiles</p>
                )}
              </div>
            </div>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Education / கல்வி *</label>
                <input className="form-input" value={form.education} onChange={e => set('education', e.target.value)} placeholder="e.g. B.Tech, M.Com" />
              </div>
              <div className="form-group">
                <label className="form-label">Profession / தொழில் *</label>
                <input className="form-input" value={form.job_profession} onChange={e => set('job_profession', e.target.value)} placeholder="e.g. Software Engineer" />
              </div>
              <div className="form-group">
                <label className="form-label">Workplace / பணிமனை</label>
                <input className="form-input" value={form.workplace} onChange={e => set('workplace', e.target.value)} placeholder="Company / Organization" />
              </div>
              <div className="form-group">
                <label className="form-label">Annual Income / வருடாந்திர வருமானம்</label>
                <select className="form-select" value={form.income} onChange={e => set('income', e.target.value)}>
                  <option value="">Select Income Range</option>
                  {['Below ₹2L','₹2L - ₹4L','₹4L - ₹6L','₹6L - ₹10L','₹10L - ₹15L','₹15L - ₹25L','Above ₹25L'].map(i=><option key={i}>{i}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Father's Name / தந்தை பெயர் *</label>
                <input className="form-input" value={form.father_name} onChange={e => set('father_name', e.target.value)} placeholder="Father's full name" />
              </div>
              <div className="form-group">
                <label className="form-label">Mother's Name / தாயார் பெயர் *</label>
                <input className="form-input" value={form.mother_name} onChange={e => set('mother_name', e.target.value)} placeholder="Mother's full name" />
              </div>
              <div className="form-group">
                <label className="form-label">No. of Siblings / உடன்பிறந்தோர்</label>
                <input className="form-input" type="number" min="0" value={form.siblings_count} onChange={e => set('siblings_count', e.target.value)} placeholder="0" />
              </div>
              <div className="form-group">
                <label className="form-label">Siblings Married / திருமணமான உடன்பிறந்தோர்</label>
                <input className="form-input" type="number" min="0" value={form.siblings_married} onChange={e => set('siblings_married', e.target.value)} placeholder="0" />
              </div>
              <div className="form-group">
                <label className="form-label">House/Land/Property / சொத்து</label>
                <select className="form-select" value={form.has_property} onChange={e => set('has_property', e.target.value)}>
                  <option value="Yes">Yes / ஆம்</option>
                  <option value="No">No / இல்லை</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Place of Birth / பிறந்த ஊர்</label>
                <input className="form-input" value={form.place_of_birth} onChange={e => set('place_of_birth', e.target.value)} placeholder="City/Town of birth" />
              </div>
              <div className="form-group span-2">
                <label className="form-label">Native Place / சொந்த ஊர்</label>
                <input className="form-input" value={form.native_place} onChange={e => set('native_place', e.target.value)} placeholder="Native town/village" />
              </div>
            </div>
          )}

          {/* STEP 4 */}
          {step === 4 && (
            <div className="form-grid">
              <div className="form-group span-2">
                <label className="form-label">Phone Number / கைபேசி எண் *</label>
                <input className="form-input" type="tel" value={form.phone}
                  onChange={e => set('phone', e.target.value.replace(/\D/,'').slice(0,10))}
                  placeholder="10-digit phone number" />
              </div>
              <div className="form-group">
                <label className="form-label">Alternate Phone / மாற்று எண்</label>
                <input className="form-input" type="tel" value={form.alternate_phone}
                  onChange={e => set('alternate_phone', e.target.value.replace(/\D/,'').slice(0,10))}
                  placeholder="Optional" />
              </div>
              <div className="form-group">
                <label className="form-label">Address / முகவரி</label>
                <input className="form-input" value={form.address} onChange={e => set('address', e.target.value)} placeholder="Short address" />
              </div>
              <div className="form-group">
                <label className="form-label">Password / கடவுச்சொல் *</label>
                <div className="input-with-icon">
                  <input className="form-input" type={showPwd ? 'text' : 'password'} value={form.password} onChange={e => set('password', e.target.value)} placeholder="Minimum 6 characters" />
                  <button type="button" className="show-pwd" onClick={() => setShowPwd(!showPwd)}>{showPwd ? '🙈' : '👁️'}</button>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password *</label>
                <input className="form-input" type="password" value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)} placeholder="Re-enter password" />
              </div>
              <div className="form-group span-2">
                <label className="form-label">Profile Photo / சுயவிவர புகைப்படம் * (9:16 ratio)</label>
                <div className="photo-upload-area" onClick={() => document.getElementById('photo-input').click()}>
                  {photoPreview ? (
                    <div className="photo-preview-wrap">
                      <img src={photoPreview} alt="Preview" className="photo-preview" />
                      <div className="photo-change-overlay">Change Photo</div>
                    </div>
                  ) : (
                    <div className="photo-upload-placeholder">
                      <span style={{fontSize:'2.5rem'}}>📸</span>
                      <p>Click to upload photo</p>
                      <p style={{fontSize:'12px',color:'var(--text-light)'}}>Recommended: 9:16 portrait ratio (e.g. 900×1600)</p>
                    </div>
                  )}
                  <input id="photo-input" type="file" accept="image/*" hidden onChange={handlePhotoChange} />
                </div>
              </div>
              <div className="form-group span-2">
                <label className="form-label">Birth Horoscope / ஜாதகம் (Optional)</label>
                <div className="file-upload-area" onClick={() => document.getElementById('horo-input').click()}>
                  <span>📄 {form.horoscope_image ? form.horoscope_image.name : 'Upload horoscope image / PDF'}</span>
                  <input id="horo-input" type="file" accept="image/*,.pdf" hidden onChange={e => set('horoscope_image', e.target.files[0])} />
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="reg-nav-btns">
            {step > 1 && (
              <button className="btn btn-outline" onClick={() => setStep(s => s-1)}>← Back</button>
            )}
            {step < 4 ? (
              <button className="btn btn-gold" onClick={handleNext}>Continue →</button>
            ) : (
              <button className="btn btn-gold" onClick={handleSubmit} disabled={loading}>
                {loading ? <><span className="spinner" style={{width:18,height:18}} /> Registering...</> : '🪷 Complete Registration'}
              </button>
            )}
          </div>

          <div className="auth-footer">
            Already registered? <Link to="/login">Login here →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
